import { FC, useState } from 'react';
// import { Table, Typography } from 'antd';
import { useQuery } from '@tanstack/react-query';
import DataRow from '@/libs/antd/components/DataRow';
import FleetModal from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import { getShareholderDetail } from '@/libs/fleet-api/services/customer';
import { FleetFile } from '@/libs/fleet-api/fetcher';
import { useModals } from './ModalProvider';
import { CustomerShareholder } from '@/libs/fleet-api/services/types';

export type ShareholderModalState = null | number | CustomerShareholder;

export type ShareholderModalProps = {
	modal: ShareholderModalState;
	onClose: () => void;
};

const ShareholderModal: FC<ShareholderModalProps> = ({ modal, onClose }) => {
	const { data, isLoading } = useQuery({
		queryKey: ['getShareholderDetail', modal] as const,
		queryFn: ({ queryKey }) => {
			const [, id] = queryKey;
			if (!id || typeof id !== 'number') return null;
			return getShareholderDetail(id);
		},
		enabled: typeof modal === 'number',
	});

	const { openPreviewModal } = useModals();

	const {
		name,
		identityNumber,
		address,
		rt,
		rw,
		phoneNumber,
		isManagement,
		shareholding,
		citizenship,
		nationality,
		identityCardType,
		postal,
		identityFile,
		// address,
		// creditLimit,
		// isActive
	} = data?.data ?? (modal as CustomerShareholder) ?? {};

	return (
		<FleetModal
			open={Boolean(modal)}
			width={940}
			cancelText="BACK"
			buttonPosition="end"
			closable={false}
			okButtonProps={{
				hidden: true,
			}}
			onCancel={() => onClose?.()}
		>
			<FleetTitle>Detil Pemegang Saham</FleetTitle>
			<DataRow
				loading={isLoading}
				items={[
					[
						['Nama Pengurus', name],
						['Kewarganegaraan', citizenship?.value],
					],
					[
						['Nationality', nationality?.value],
						['Jenis Identitas', identityCardType?.value],
					],
					[
						['No. ID', identityNumber],
						[
							'Identitas File',
							identityFile ? (
								<a
									href="#"
									onClick={(e) => {
										e.preventDefault();
										openPreviewModal(identityFile as FleetFile);
									}}
								>
									Lihat File
								</a>
							) : (
								'-'
							),
						],
					],
					[
						['Alamat', address],
						['RT/RW', `${rt}/${rw}`],
					],
					[
						['Kode Pos', postal?.postalCode],
						['Kelurahan', postal?.locationName],
					],
					[
						['Kecamatan', postal?.districtName],
						['Kota', postal?.cityName],
					],
					[
						['No. Telepon', phoneNumber],
						['Kepemilikan Saham', shareholding + '%'],
					],
					[['Merupakan Pengurus?', isManagement ? 'Ya' : 'Tidak']],
				]}
				style={{
					marginBottom: 20,
				}}
			/>
		</FleetModal>
	);
};

export default ShareholderModal;

export const useShareholderModal = () => {
	return useState<ShareholderModalState>(null);
};
